// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  width: 100%;
  height: 100vh;
  padding-top: 104px; /* 56px main navbar + 48px secondary topbar */
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
}

/* Make scrollbar visible */
.table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: transparent;
}

.table-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.tableStructureBoard {
  width: 100%;
  position: relative;
  overflow-x: hidden;
}

.tableStructureBoard.grid-view {
  display: flex !important;
  flex-direction: column;
  gap: 20px;
  padding: 18px 24px 140px;
  min-height: calc(100vh - 220px);
}

.tableStructureBoard.coordinate-view {
  position: relative;
  min-height: calc(100vh - 220px);
}

.tableStructureBoard.grid-view > div {
  position: relative;
}

/* ── Last accessed badge ── */
.ts-last-accessed-badge {
  position: absolute;
  top: -10px;
  left: 33%;
  transform: translateX(-50%);
  background: #0860e6;
  color: #ffffff;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;
  z-index: 3;
  pointer-events: none;
}

/* ── Action buttons rendered directly in index.js, overlaid on card bottom-right ── */
.ts-action-btns {
  position: absolute;
  bottom: 14px;
  right: 16px;
  display: flex;
  align-items: center;
  z-index: 2;
  pointer-events: all;
}

.table-layout-area-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 12px;
  width: 100%;
}

.table-layout-area-section {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.table-layout-area-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 14px;
}

.table-layout-area-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  flex: 1;
}

.table-layout-area-line {
  height: 1px;
  flex: 1;
  min-width: 24px;
  background: linear-gradient(90deg, rgba(205, 215, 230, 0.9) 0%, rgba(205, 215, 230, 0.2) 100%);
}

.table-layout-area-title {
  margin: 0;
  font-size: 19px;
  line-height: 1;
  color: #273246;
  font-weight: 800;
  letter-spacing: -0.01em;
  white-space: nowrap;
}

.table-layout-area-count {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
}

.table-layout-area-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid #d8e0ed;
  box-shadow: 0 8px 18px rgba(60, 82, 120, 0.08);
  font-size: 11px;
  font-weight: 700;
  color: #7d8ba2;
  letter-spacing: 0.06em;
  white-space: nowrap;
}

.table-layout-branding {
  grid-column: 1 / -1;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center;
  margin: 38px 0 8px;
  color: #bbc7d8;
  pointer-events: none;
}

.table-layout-branding h2 {
  margin: 0;
  font-size: 36px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: #D7DFEA;
}

.table-layout-branding p {
  margin: 8px 0 0;
  font-size: 14px;
  color: #A6B4C7;
  line-height: 1.4;
  font-weight: 500;
}

.table-layout-branding p span {
  color: #d91e4f;
}

.tableLayoutBottombar {
  background-color: var(--surface-white);
  margin-top: 10px;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
}

.tableBottombarRight {
  display: flex;
  gap: 6px;
  align-items: center;
}

.bottombar-icon-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 56px;
  margin-bottom: 4px;
}

.bottombar-icon-btn:hover {
  background-color: #f3f4f6;
}

.bottombar-icon-btn:active {
  background-color: #e5e7eb;
}

.bottombar-icon-btn span {
  font-size: 10px;
  font-weight: 500;
  color: #535861;
  margin-top: 4px;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .tableLayoutBottombar {
    position: sticky;
    bottom: 0;
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
  }

  .tableStructureBoard.grid-view {
    gap: 16px;
    padding: 14px 14px 120px;
  }

  .tableStructureBoard.coordinate-view {
    min-height: calc(100vh - 180px);
  }

  .table-layout-area-title {
    font-size: 16px;
  }
  .table-layout-area-grid {
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    gap: 16px 10px;
  }
  .table-layout-area-pill {
    font-size: 10px;
    padding: 5px 10px;
  }

  .table-layout-branding h2 {
    font-size: clamp(28px, 8vw, 40px);
  }

  .table-layout-branding p {
    font-size: clamp(15px, 4vw, 22px);
  }

  .table-action-btn {
    width: 28px;
    height: 28px;
  }

  .table-action-icon {
    width: 14px;
    height: 14px;
  }
}

@media (max-width: 480px) {
  .tableStructureBoard.grid-view {
    gap: 14px;
    padding: 8px 10px 100px;
    min-height: calc(100vh - 180px);
  }

  .tableStructureBoard.coordinate-view {
    height: calc(100vh - 160px);
  }

  .table-layout-area-title {
    font-size: 14px;
  }
  .table-layout-area-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 8px;
  }
  .table-layout-area-pill {
    font-size: 9px;
    padding: 5px 8px;
  }

  .table-layout-area-header {
    margin: 2px 0 6px;
    gap: 4px;
  }

  .table-layout-branding h2 {
    font-size: clamp(22px, 7vw, 32px);
  }

  .table-layout-branding p {
    font-size: clamp(13px, 3.5vw, 18px);
    margin-top: 10px;
  }

  .table-action-btn {
    width: 24px;
    height: 24px;
    border-radius: 7px;
  }

  .table-action-icon {
    width: 12px;
    height: 12px;
  }
}

.table-action-buttons {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 5;
}

.table-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 32px;
  height: 32px;
  border: 1px solid #cfd6e2;
  border-radius: 10px;
  background-color: #f0f2f5;
  cursor: pointer;
  transition: all 0.15s ease;
  color: #4b5563;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  line-height: 1;
}

.table-action-btn:hover {
  background-color: #ffffff;
  border-color: #9ca3af;
}

.table-action-btn:active {
  background-color: #e5e7eb;
}

.table-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.table-action-btn-payment {
  background-color: #0860e6;
  color: #fff;
  border-color: #0860e6;
}

.table-action-btn-payment:hover {
  background-color: #0650c0;
  border-color: #0650c0;
}

.table-action-btn-payment:active {
  background-color: #0445a5;
}

.table-action-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

@keyframes blinkDot {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

@keyframes blinkBorder {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 150, 255, 0.8);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(0, 150, 255, 0.2);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 150, 255, 0.8);
  }
}

.blink {
  animation: blinkAnim 1s infinite;
}

@keyframes blinkAnim {
  0% {
    background-color: transparent;
  }
  50% {
    /* changed 255, 165, 0, 0.5 from 255, 0, 0, 0.15 */
    background-color: rgba(255, 165, 0, 0.5);
  }
  100% {
    background-color: transparent;
  }
}

/* ═══ DARK THEME — table-layout ═══ */
.dark .table-container {
  background: #0f172a;
  scrollbar-color: #334155 transparent;
}
.dark .table-container::-webkit-scrollbar-thumb { background: #334155; }

.dark .table-layout-area-title { color: #e2e8f0; }
.dark .table-layout-area-count { color: #64748b; }
.dark .table-layout-area-line {
  background: linear-gradient(90deg, rgba(71,85,105,0.9) 0%, rgba(71,85,105,0.2) 100%);
}
.dark .table-layout-area-pill {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .table-layout-branding h2 { color: #334155; }
.dark .table-layout-branding p  { color: #475569; }

.dark .tableLayoutBottombar { background-color: #1e293b; }
.dark .bottombar-icon-btn:hover  { background-color: #334155; }
.dark .bottombar-icon-btn:active { background-color: #475569; }
.dark .bottombar-icon-btn span   { color: #94a3b8; }

.dark .table-action-btn {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .table-action-btn:hover { background-color: #334155; border-color: #475569; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/table-layout/table-layout.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB,EAAE,6CAA6C;EACjE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA,sFAAsF;AACtF;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,WAAW;EACX,OAAO;EACP,eAAe;EACf,8FAA8F;AAChG;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,SAAS;IACT,wDAAwD;EAC1D;;EAEA;IACE,SAAS;IACT,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;EACA;IACE,4DAA4D;IAC5D,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS;IACT,uBAAuB;IACvB,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;EACA;IACE,gDAAgD;IAChD,aAAa;EACf;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,mCAAmC;IACnC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,kDAAkD;IAClD,wCAAwC;EAC1C;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;EACnB,oCAAoC;AACtC;AACA,kDAAkD,mBAAmB,EAAE;;AAEvE,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD;EACE,oFAAoF;AACtF;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;;AAElD,8BAA8B,yBAAyB,EAAE;AACzD,mCAAmC,yBAAyB,EAAE;AAC9D,mCAAmC,yBAAyB,EAAE;AAC9D,mCAAmC,cAAc,EAAE;;AAEnD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,gCAAgC,yBAAyB,EAAE,qBAAqB,EAAE","sourcesContent":[".table-container {\n  width: 100%;\n  height: 100vh;\n  padding-top: 104px; /* 56px main navbar + 48px secondary topbar */\n  box-sizing: border-box;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: #fff;\n}\n\n/* Make scrollbar visible */\n.table-container::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.table-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.table-container::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n.tableStructureBoard {\n  width: 100%;\n  position: relative;\n  overflow-x: hidden;\n}\n\n.tableStructureBoard.grid-view {\n  display: flex !important;\n  flex-direction: column;\n  gap: 20px;\n  padding: 18px 24px 140px;\n  min-height: calc(100vh - 220px);\n}\n\n.tableStructureBoard.coordinate-view {\n  position: relative;\n  min-height: calc(100vh - 220px);\n}\n\n.tableStructureBoard.grid-view > div {\n  position: relative;\n}\n\n/* ── Last accessed badge ── */\n.ts-last-accessed-badge {\n  position: absolute;\n  top: -10px;\n  left: 33%;\n  transform: translateX(-50%);\n  background: #0860e6;\n  color: #ffffff;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  padding: 3px 10px;\n  border-radius: 999px;\n  white-space: nowrap;\n  z-index: 3;\n  pointer-events: none;\n}\n\n/* ── Action buttons rendered directly in index.js, overlaid on card bottom-right ── */\n.ts-action-btns {\n  position: absolute;\n  bottom: 14px;\n  right: 16px;\n  display: flex;\n  align-items: center;\n  z-index: 2;\n  pointer-events: all;\n}\n\n.table-layout-area-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 0 12px;\n  width: 100%;\n}\n\n.table-layout-area-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.table-layout-area-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));\n  gap: 14px;\n}\n\n.table-layout-area-heading {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n  flex: 1;\n}\n\n.table-layout-area-line {\n  height: 1px;\n  flex: 1;\n  min-width: 24px;\n  background: linear-gradient(90deg, rgba(205, 215, 230, 0.9) 0%, rgba(205, 215, 230, 0.2) 100%);\n}\n\n.table-layout-area-title {\n  margin: 0;\n  font-size: 19px;\n  line-height: 1;\n  color: #273246;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n}\n\n.table-layout-area-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: #9ca3af;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.table-layout-area-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 28px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: #ffffff;\n  border: 1px solid #d8e0ed;\n  box-shadow: 0 8px 18px rgba(60, 82, 120, 0.08);\n  font-size: 11px;\n  font-weight: 700;\n  color: #7d8ba2;\n  letter-spacing: 0.06em;\n  white-space: nowrap;\n}\n\n.table-layout-branding {\n  grid-column: 1 / -1;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  text-align: center;\n  margin: 38px 0 8px;\n  color: #bbc7d8;\n  pointer-events: none;\n}\n\n.table-layout-branding h2 {\n  margin: 0;\n  font-size: 36px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n  color: #D7DFEA;\n}\n\n.table-layout-branding p {\n  margin: 8px 0 0;\n  font-size: 14px;\n  color: #A6B4C7;\n  line-height: 1.4;\n  font-weight: 500;\n}\n\n.table-layout-branding p span {\n  color: #d91e4f;\n}\n\n.tableLayoutBottombar {\n  background-color: var(--surface-white);\n  margin-top: 10px;\n  padding: 10px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.tableBottombarRight {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.bottombar-icon-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 56px;\n  margin-bottom: 4px;\n}\n\n.bottombar-icon-btn:hover {\n  background-color: #f3f4f6;\n}\n\n.bottombar-icon-btn:active {\n  background-color: #e5e7eb;\n}\n\n.bottombar-icon-btn span {\n  font-size: 10px;\n  font-weight: 500;\n  color: #535861;\n  margin-top: 4px;\n  white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n  .tableLayoutBottombar {\n    position: sticky;\n    bottom: 0;\n    padding-bottom: calc(10px + env(safe-area-inset-bottom));\n  }\n\n  .tableStructureBoard.grid-view {\n    gap: 16px;\n    padding: 14px 14px 120px;\n  }\n\n  .tableStructureBoard.coordinate-view {\n    min-height: calc(100vh - 180px);\n  }\n\n  .table-layout-area-title {\n    font-size: 16px;\n  }\n  .table-layout-area-grid {\n    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));\n    gap: 16px 10px;\n  }\n  .table-layout-area-pill {\n    font-size: 10px;\n    padding: 5px 10px;\n  }\n\n  .table-layout-branding h2 {\n    font-size: clamp(28px, 8vw, 40px);\n  }\n\n  .table-layout-branding p {\n    font-size: clamp(15px, 4vw, 22px);\n  }\n\n  .table-action-btn {\n    width: 28px;\n    height: 28px;\n  }\n\n  .table-action-icon {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .tableStructureBoard.grid-view {\n    gap: 14px;\n    padding: 8px 10px 100px;\n    min-height: calc(100vh - 180px);\n  }\n\n  .tableStructureBoard.coordinate-view {\n    height: calc(100vh - 160px);\n  }\n\n  .table-layout-area-title {\n    font-size: 14px;\n  }\n  .table-layout-area-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 16px 8px;\n  }\n  .table-layout-area-pill {\n    font-size: 9px;\n    padding: 5px 8px;\n  }\n\n  .table-layout-area-header {\n    margin: 2px 0 6px;\n    gap: 4px;\n  }\n\n  .table-layout-branding h2 {\n    font-size: clamp(22px, 7vw, 32px);\n  }\n\n  .table-layout-branding p {\n    font-size: clamp(13px, 3.5vw, 18px);\n    margin-top: 10px;\n  }\n\n  .table-action-btn {\n    width: 24px;\n    height: 24px;\n    border-radius: 7px;\n  }\n\n  .table-action-icon {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n.table-action-buttons {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: 5;\n}\n\n.table-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #cfd6e2;\n  border-radius: 10px;\n  background-color: #f0f2f5;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  color: #4b5563;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n  line-height: 1;\n}\n\n.table-action-btn:hover {\n  background-color: #ffffff;\n  border-color: #9ca3af;\n}\n\n.table-action-btn:active {\n  background-color: #e5e7eb;\n}\n\n.table-action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.table-action-btn-payment {\n  background-color: #0860e6;\n  color: #fff;\n  border-color: #0860e6;\n}\n\n.table-action-btn-payment:hover {\n  background-color: #0650c0;\n  border-color: #0650c0;\n}\n\n.table-action-btn-payment:active {\n  background-color: #0445a5;\n}\n\n.table-action-icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n@keyframes blinkDot {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.3;\n  }\n}\n\n@keyframes blinkBorder {\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 150, 255, 0.8);\n  }\n  50% {\n    box-shadow: 0 0 0 6px rgba(0, 150, 255, 0.2);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(0, 150, 255, 0.8);\n  }\n}\n\n.blink {\n  animation: blinkAnim 1s infinite;\n}\n\n@keyframes blinkAnim {\n  0% {\n    background-color: transparent;\n  }\n  50% {\n    /* changed 255, 165, 0, 0.5 from 255, 0, 0, 0.15 */\n    background-color: rgba(255, 165, 0, 0.5);\n  }\n  100% {\n    background-color: transparent;\n  }\n}\n\n/* ═══ DARK THEME — table-layout ═══ */\n.dark .table-container {\n  background: #0f172a;\n  scrollbar-color: #334155 transparent;\n}\n.dark .table-container::-webkit-scrollbar-thumb { background: #334155; }\n\n.dark .table-layout-area-title { color: #e2e8f0; }\n.dark .table-layout-area-count { color: #64748b; }\n.dark .table-layout-area-line {\n  background: linear-gradient(90deg, rgba(71,85,105,0.9) 0%, rgba(71,85,105,0.2) 100%);\n}\n.dark .table-layout-area-pill {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .table-layout-branding h2 { color: #334155; }\n.dark .table-layout-branding p  { color: #475569; }\n\n.dark .tableLayoutBottombar { background-color: #1e293b; }\n.dark .bottombar-icon-btn:hover  { background-color: #334155; }\n.dark .bottombar-icon-btn:active { background-color: #475569; }\n.dark .bottombar-icon-btn span   { color: #94a3b8; }\n\n.dark .table-action-btn {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .table-action-btn:hover { background-color: #334155; border-color: #475569; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
